import './index.scss';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { observer } from 'mobx-react-lite';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { changePassword as changePasswordApi } from '@api/user-api';
import { toastOptions } from '@shared/index';

const validationSchema = Yup.object().shape({
    password_old: Yup.string()
        .required('Köhnə parolu daxil edin')
        .min(6, 'Parol ən azı 6 simvol olmalıdır'),
    password_new: Yup.string()
        .required('Yeni parolu daxil edin')
        .min(6, 'Parol ən azı 6 simvol olmalıdır'),  
    password2_new: Yup.string()
        .required('Yeni parolu təkrar edin')
        .min(6, 'Parol ən azı 6 simvol olmalıdır'),  
})

const formOptions = { resolver: yupResolver(validationSchema) };

const EditPasswordComponent = observer(() => {
    const [ isDisplaySecondPassword, setIsDisplaySecondPassword ] = useState(false)
    const [ isDifferentPasswordsError, setIsDifferentPasswordsError ] = useState(false)
    const { register, reset, handleSubmit, formState: { errors } } = useForm(formOptions);
    const onSubmit = ({ password_old, password_new, password2_new }) => {
        if (password_new !== password2_new) {
            setIsDifferentPasswordsError(true);
            return;
        }
        const payload = { old_password: password_old, password: password_new }
        changePasswordApi(payload)
        .then(() => {
            reset({
                password_old: '',
                password_new: '',
                password2_new: ''
            });
            setIsDisplaySecondPassword(false);
            toast.success('Parol uğurla dəyişdirildi', toastOptions);
        })
        .catch(() => {
            reset({
                password_old: '',
                password_new: '',
                password2_new: ''
            });
            setIsDisplaySecondPassword(false);
            toast.error('Parol dəyişdirməkdə xəta', toastOptions);
        })
    }
    return (
        <div className="edit-password-component container">
            <div className="title">
                Parol
            </div>
            <form className="form" onSubmit={handleSubmit(onSubmit)}>
                <div className="form-control-block">
                    <label className="form-label">Köhnə parol</label>
                    <div className="row">
                        <div className="col-md-12">
                            <input 
                                type="password" 
                                className="form-control" 
                                placeholder=""
                                {...register("password_old")}
                            />
                            {errors.password_old?.message && (
                                <p className="error">{errors.password_old?.message}</p>
                            )}
                        </div>
                    </div>
                </div>
                <div className="form-control-block">
                    <label className="form-label">Yeni parol</label>
                    <div className="row">
                        <div className="col-md-12">
                            <input 
                                type="password" 
                                className="form-control" 
                                placeholder=""
                                {...register("password_new")}
                                onFocus={() => {
                                    setIsDisplaySecondPassword(true);
                                    isDifferentPasswordsError && setIsDifferentPasswordsError(false);
                                }}
                            />
                            {errors.password_new?.message && (
                                <p className="error">{errors.password_new?.message}</p>
                            )}
                        </div>
                    </div>
                </div>
                <div className="hint">👍 8 və ya daha çox simvoldan ibarət parol yaratmağı tövsiyə edirik</div>
                <div className={`form-control-block ${!isDisplaySecondPassword && 'second-password'}`}>
                    <label className="form-label">Parolu təkrar edin</label>
                    <div className="row">
                        <div className="col-md-12">
                            <input 
                                type="password" 
                                className="form-control" 
                                placeholder=""
                                {...register("password2_new")}
                                onFocus={() => {
                                    isDifferentPasswordsError && setIsDifferentPasswordsError(false);
                                }}
                            />
                            {errors.password2_new?.message && (
                                <p className="error">{errors.password2_new?.message}</p>
                            )}
                            {isDifferentPasswordsError && (
                                <p className="error">😢 Parollar uyğun olmalıdır</p>
                            )}
                        </div>
                    </div>
                </div>
                <button>
                    Parolu dəyişdir
                </button>
            </form>
        </div>
    );
})

export { EditPasswordComponent }